import {
    Component,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { View } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import { SelectItem, Table } from '../../shared';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging';
import { IUserInfo } from '../../user-info';

let ccpc: CompanyCalendarPresenterComponent;
@Component({
    selector: 'ef-company-calendar-presenter',
    templateUrl: './company-calendar-presenter.component.html',
    styleUrls: ['./company-calendar-presenter.component.scss'],
    standalone: false
})
export class CompanyCalendarPresenterComponent
    extends DisplayErrors<fromDataServices.CompanyCalendar.CompanyCalendar>
    implements OnInit, OnChanges
{
    public editing: fromDataServices.CompanyCalendar.CompanyCalendar =
        {} as fromDataServices.CompanyCalendar.CompanyCalendar;
    clonedCompanyDates: {
        [i: string]: fromDataServices.CompanyCalendar.CompanyCalendar;
    } = {};

    private CompanyDatesSubject = new ReplaySubject<
        fromDataServices.CompanyCalendar.CompanyCalendar[]
    >(1);
    private _companydates: Array<fromDataServices.CompanyCalendar.CompanyCalendar>;

    @Input() set companyDates(
        value: Array<fromDataServices.CompanyCalendar.CompanyCalendar>
    ) {
        this._companydates = value.sort(
            (a, b) =>
                a.ScheduledEndDate.getTime() - b.ScheduledEndDate.getTime()
        );
        this.CompanyDatesSubject.next(this._companydates);

        this.eventTypesFilterSelectItem = [];
        this.eventDescFilterSelectItem = [];

        if (value.length > 0) {
            value.forEach(item => {
                if (
                    item.ScheduledDateType == 'PPE' ||
                    item.ScheduledDateType == 'FYE' ||
                    item.ScheduledDateType == 'GEN' ||
                    item.ScheduledDateType == 'HOL'
                ) {
                    if (item.ScheduledDateType == 'HOL') {
                        this.eventTypesMultiSelectItem.push({
                            value: item.ScheduledDateType,
                            label: 'Holiday'
                        });
                    } else if (item.ScheduledDateType == 'GEN') {
                        this.eventTypesMultiSelectItem.push({
                            value: item.ScheduledDateType,
                            label: 'Custom Date'
                        });
                    } else if (item.ScheduledDateType == 'PPE') {
                        this.eventTypesMultiSelectItem.push({
                            value: item.ScheduledDateType,
                            label: 'Pay Period'
                        });
                    } else {
                        this.eventTypesMultiSelectItem.push({
                            value: item.ScheduledDateType,
                            label: item.ScheduledDatePurpose
                        });
                    }
                }
                this.eventTypesFilterSelectItem.push({
                    value: item.ScheduledDateType,
                    label: item.ScheduledDateType
                });
                this.eventDescFilterSelectItem.push({
                    value: item.ScheduledDatePurpose,
                    label: item.ScheduledDatePurpose
                });
            });
            this.eventTypesMultiSelectItem =
                this.eventTypesMultiSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.value === v.value) === i
                );
            this.eventTypesFilterSelectItem =
                this.eventTypesFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.value === v.value) === i
                );
            this.eventDescFilterSelectItem =
                this.eventDescFilterSelectItem.filter(
                    (v, i, a) => a.findIndex(t => t.value === v.value) === i
                );
            this.eventTypesFilterSelectItem =
                this.eventTypesFilterSelectItem.sort((a, b) =>
                    a.label.localeCompare(b.label)
                );
            this.eventDescFilterSelectItem =
                this.eventDescFilterSelectItem.sort((a, b) =>
                    a.label.localeCompare(b.label)
                );
        }
    }
    get companyDates(): Array<fromDataServices.CompanyCalendar.CompanyCalendar> {
        return this._companydates;
    }

    showAllButton: HTMLElement;
    showAllButtonLabel = 'Show All';

    coloredDiv = document.getElementById('coloredDiv');

    moment: any;
    // events: any[] = [];
    @Input() events: any[];
    options: any;

    eventColor: string;
    eventType: string;

    active = true;

    displayEventDialog = false;
    displayColorOptions = false;

    selectedCalendarDate: Date;

    eventFormGroup: UntypedFormGroup;
    multiUpdateFormGroup: UntypedFormGroup;

    eventTypesSelectItem: SelectItem[] = [];
    eventTypesMultiSelectItem: SelectItem[] = [];
    eventTypesFilterSelectItem: SelectItem[] = [];

    eventDescFilterSelectItem: SelectItem[] = [];

    @Output() SaveEvent = new ReplaySubject<any>(1);
    @Output() DeleteEvent = new ReplaySubject<any>(1);
    @Output() LoadAllDates = new ReplaySubject(1);
    @Output() LoadDates = new ReplaySubject<any>(1);

    cbxValue = true;
    cbxLabel = "Show all for current year";
    start: any;
    end: any;
    labelTextColor = 'black';
    calendarYear: any;
    calendarMonth: any;

    calendarDate: any;

    IsAdministrator = false;

    row: any;

    selectedEvent: fromDataServices.CompanyCalendar.CompanyCalendar;

    @Input() userInfo: IUserInfo;

    @ViewChild('CCTable', { static: true }) CCTable: Table;

    startDate: Date;
    endDate: Date;
    description: string;
    type: fromDataServices.CompanyCalendar.CompanyCalendar;
    color: string;
    // private CompanyDatesSubject = new ReplaySubject<
    //     Array<fromDataServices.CompanyCalendar.CompanyCalendar>
    // >(1);

    monthsSelectItem: SelectItem[];

    constructor(private log: LoggingService) {
        super();
        ccpc = this;
        this.moment = moment;

        this.eventFormGroup = new UntypedFormGroup({
            startDate: new UntypedFormControl(null),
            endDate: new UntypedFormControl(null),
            description: new UntypedFormControl(null),
            type: new UntypedFormControl(null),
            color: new UntypedFormControl(null)
        });
        this.multiUpdateFormGroup = new UntypedFormGroup({
            multi_type: new UntypedFormControl(null),
            multi_color: new UntypedFormControl(null),
            apply: new UntypedFormControl(null)
        });
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.items) {
            this.CompanyDatesSubject.next(changes.items.currentValue);
        }
    }
    setupSubscriptions() {
        this.eventFormGroup.controls['startDate'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.eventFormGroup.controls['endDate'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.eventFormGroup.controls['description'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.eventFormGroup.controls['type'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.eventType = null;
                    this.eventType = value.label;
                }
            });
        this.eventFormGroup.controls['color'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    this.eventColor = null;
                    this.eventColor = value;
                }
            });
        this.multiUpdateFormGroup.controls['apply'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
        this.multiUpdateFormGroup.controls['multi_color'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                    if (
                        this.hexToRgb(value).r +
                            this.hexToRgb(value).g +
                            this.hexToRgb(value).b >
                        275
                    ) {
                        this.labelTextColor = '#000000';
                    } else {
                        this.labelTextColor = '#FFFFFF';
                    }
                }
            });
        this.multiUpdateFormGroup.controls['multi_type'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value != null) {
                }
            });
    }

    hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
              }
            : null;
    }

    setTextColor(value) {
        return this.hexToRgb(value).r +
            this.hexToRgb(value).g +
            this.hexToRgb(value).b >
            275
            ? '#000000'
            : '#FFFFFF';
    }

    ngOnDestroy() {
        this.active = false;
    }

    ngOnInit(): void {
        if (this.userInfo) {
            if (this.userInfo.DefaultRoleGroupID == 1) {
                this.IsAdministrator = true;
            }
        }

        this.monthsSelectItem = [
            {
                value: '01',
                label: 'January'
            },
            {
                value: '02',
                label: 'Feburary'
            },
            {
                value: '03',
                label: 'March'
            },
            {
                value: '04',
                label: 'April'
            },
            {
                value: '05',
                label: 'May'
            },
            {
                value: '06',
                label: 'June'
            },
            {
                value: '07',
                label: 'July'
            },
            {
                value: '08',
                label: 'August'
            },
            {
                value: '09',
                label: 'September'
            },
            {
                value: '10',
                label: 'October'
            },
            {
                value: '11',
                label: 'November'
            },
            {
                value: '12',
                label: 'December'
            }
        ];

        this.eventTypesSelectItem = [
            {
                value: 'HOL',
                label: 'Holiday'
            },
            {
                value: 'GEN',
                label: 'Custom Date'
            }
        ];
        this.options = {
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            defaultDate: new Date(),
            // customButtons: {
            //     showAll: {
            //         text: 'Show All',
            //         click: function () {
            //             ccpc.showAllButton
            //             ccpc.LoadAllDates.next()
            //         }
            //     }
            // },
            height: 600,
            header: {
                left: 'prev',
                center: 'title',
                right: 'next'
            },
            dateClick: e => {
                if (this.IsAdministrator) {
                    this.selectedCalendarDate = e.date;
                    this.eventDialog();
                }
            },
            eventClick: ccpc.eventSelected.bind(this),
            eventRender: ccpc.eventRender.bind(this),
            datesRender: function (e) {
                setTimeout(() => {
                    let month;
                    if (e.view.title.includes('January')) {
                        month = '01';
                    } else if (e.view.title.includes('February')) {
                        month = '02';
                    } else if (e.view.title.includes('March')) {
                        month = '03';
                    } else if (e.view.title.includes('April')) {
                        month = '04';
                    } else if (e.view.title.includes('May')) {
                        month = '05';
                    } else if (e.view.title.includes('June')) {
                        month = '06';
                    } else if (e.view.title.includes('July')) {
                        month = '07';
                    } else if (e.view.title.includes('August')) {
                        month = '08';
                    } else if (e.view.title.includes('September')) {
                        month = '09';
                    } else if (e.view.title.includes('October')) {
                        month = '10';
                    } else if (e.view.title.includes('November')) {
                        month = '11';
                    } else if (e.view.title.includes('December')) {
                        month = '12';
                    }
                    const str = e.view.title.split(' ');
                    const year = str[1];
                    ccpc.calendarYear = year;
                    ccpc.calendarMonth = month;
                    ccpc.cbxLabel = `Show all for ${year}`;
                    if (ccpc.cbxValue == true) {
                        ccpc.start = `01/01/${year}`;
                        ccpc.end = `12/31/${year}`;
                    } else {
                        ccpc.start = `${month}/01/${year}`;
                        ccpc.end = `${month}/${ccpc.getMonthEndForCalendarDate(
                            month
                        )}/${year}`;
                    }
                    ccpc.LoadDates.next({
                        ScheduledStartDate: ccpc.start,
                        ScheduledEndDate: ccpc.end
                    });
                }, 0);
            }
        };
        this.setupSubscriptions();
    }

    eventRender(info: { event: EventModel; el: any; view: View }) {
        info.el.setAttribute('data-toggle', 'tooltip');
        info.el.setAttribute('data-placement', 'top');
        info.el.setAttribute('title', info.event.title);
    }

    datesSelected(selectInfo: { start: Date; end: Date }) {
        // Handle date range selection
        if (this.IsAdministrator) {
            this.selectedCalendarDate = selectInfo.start;
            this.eventDialog();
        }
    }

    datesRender(renderInfo: { view: { title: string } }) {
        // Handle when calendar dates are rendered (month/view changes)
        setTimeout(() => {
            let month;
            if (renderInfo.view.title.includes('January')) {
                month = '01';
            } else if (renderInfo.view.title.includes('February')) {
                month = '02';
            } else if (renderInfo.view.title.includes('March')) {
                month = '03';
            } else if (renderInfo.view.title.includes('April')) {
                month = '04';
            } else if (renderInfo.view.title.includes('May')) {
                month = '05';
            } else if (renderInfo.view.title.includes('June')) {
                month = '06';
            } else if (renderInfo.view.title.includes('July')) {
                month = '07';
            } else if (renderInfo.view.title.includes('August')) {
                month = '08';
            } else if (renderInfo.view.title.includes('September')) {
                month = '09';
            } else if (renderInfo.view.title.includes('October')) {
                month = '10';
            } else if (renderInfo.view.title.includes('November')) {
                month = '11';
            } else if (renderInfo.view.title.includes('December')) {
                month = '12';
            }

            let year;
            const yearMatch = renderInfo.view.title.match(/\d{4}/);
            if (yearMatch) {
                year = yearMatch[0];
            }

            if (month && year) {
                this.calendarYear = year;
                this.calendarMonth = month;

                // Load dates for the current view
                this.LoadDates.next({
                    ScheduledStartDate: `${month}/01/${year}`,
                    ScheduledEndDate: `${month}/${this.getMonthEndForCalendarDate(parseInt(month))}/${year}`
                });
            }
        }, 0);
    }

    eventSelected(clickInfo: { event: { id: string; title: string } }) {
        // Handle event click
        if (this.row != null) {
            this.row.classList.remove('highlight');
        }
        this.row = document.getElementById(`row-${clickInfo.event.id.toString()}`);
        if (!this.row) {
            return;
        }
        this.row.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
        this.row.classList.add('highlight');
    }

    onEditInit($event: {
        data: fromDataServices.CompanyCalendar.CompanyCalendar;
    }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: fromDataServices.CompanyCalendar.CompanyCalendar) {
        this.clonedCompanyDates[rowData.id] = { ...rowData };
        this.editing = rowData;
        this.log.verbose('onRowEditInit');
    }

    onRowEditSave(rowData: fromDataServices.CompanyCalendar.CompanyCalendar) {
        this.SaveEvent.next({
            ScheduledDateID: rowData.ScheduledDateID,
            ScheduledDateType: rowData.ScheduledDateType,
            ScheduledDatePurpose: rowData.ScheduledDatePurpose,
            ScheduledStartDate: moment(rowData.ScheduledEndDate).format(
                'MM/DD/YYYY'
            ),
            ScheduledEndDate: moment(rowData.ScheduledEndDate).format(
                'MM/DD/YYYY'
            ),
            DateColor: rowData.DateColor
        });
        delete this.clonedCompanyDates[rowData.id];
        delete this.editing;
        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: fromDataServices.CompanyCalendar.CompanyCalendar) {
        delete this.clonedCompanyDates[item.id];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }

    // onRowSelect(event) {
    //     this.calendarDate = event.data.ScheduledEndDate;
    //     let calendarApi = this.calendarComponent.getApi();
    //     calendarApi.gotoDate(this.calendarDate);
    // }

    onCompanyDateDelete(rowData) {
        this.DeleteEvent.next(rowData);
    }

    colorMultiUpdate() {
        const length = this.companyDates.length;
        this.companyDates.forEach(item => {
            if (
                item.ScheduledDateType.trim() ==
                    this.multiUpdateFormGroup.controls[
                        'multi_type'
                    ].value.trim() &&
                this.multiUpdateFormGroup.controls['multi_color'].value != null
            ) {
                this.SaveEvent.next({
                    ScheduledDateID: item.ScheduledDateID,
                    ScheduledDateType:
                        this.multiUpdateFormGroup.controls['multi_type'].value,
                    ScheduledDatePurpose: item.ScheduledDatePurpose,
                    ScheduledStartDate: moment(item.ScheduledEndDate).format(
                        'MM/DD/YYYY'
                    ),
                    ScheduledEndDate: moment(item.ScheduledEndDate).format(
                        'MM/DD/YYYY'
                    ),
                    DateColor:
                        this.multiUpdateFormGroup.controls['multi_color'].value
                });
            }
            if (
                this.companyDates.findIndex(x => x == item) == length - 1 &&
                this.multiUpdateFormGroup.controls['multi_type'].value !=
                    null &&
                this.multiUpdateFormGroup.controls['multi_color'].value != null
            ) {
                this.multiUpdateFormGroup.controls['multi_type'].reset();
                this.multiUpdateFormGroup.controls['multi_color'].reset();
            }
        });
        this.displayColorOptions = false;
    }

    showAllDates(event) {
        //const year = Date.now().toString().substring(0, 4);
        if (event.checked === true) {
            this.LoadDates.next({
                ScheduledStartDate: `01/01/${this.calendarYear}`,
                ScheduledEndDate: `12/31/${this.calendarYear}`
            });
        } else {
            this.LoadDates.next({
                ScheduledStartDate: `${this.calendarMonth}/01/${this.calendarYear}`,
                ScheduledEndDate: `${
                    this.calendarMonth
                }/${ccpc.getMonthEndForCalendarDate(this.calendarMonth)}/${
                    this.calendarYear
                }`
            });
        }
    }

    eventDialog() {
        this.displayEventDialog = true;
        this.eventFormGroup.controls['startDate'].patchValue(
            this.selectedCalendarDate
        );
        this.eventFormGroup.controls['endDate'].patchValue(
            this.selectedCalendarDate
        );
    }

    confirmDialog() {
        this.addEvent();
        this.displayEventDialog = false;
    }

    cancelDialog() {
        this.displayEventDialog = false;
    }

    addEvent() {
        this.SaveEvent.next({
            ScheduledDateID: -1,
            ScheduledDateType: this.eventType,
            ScheduledDatePurpose: this.description,
            ScheduledStartDate: moment(this.selectedCalendarDate).format('MM/DD/YYYY'),
            ScheduledEndDate: moment(this.selectedCalendarDate).format('MM/DD/YYYY'),
            DateColor: this.color
        });
        // this.SaveEvent.next({
        //     ScheduledDateID: -1,
        //     ScheduledDateType: this.eventFormGroup.controls['type'].value,
        //     ScheduledDatePurpose:
        //         this.eventFormGroup.controls['description'].value,
        //     ScheduledStartDate: moment(
        //         this.eventFormGroup.controls['startDate'].value
        //     ).format('MM/DD/YYYY'),
        //     ScheduledEndDate: moment(
        //         this.eventFormGroup.controls['endDate'].value
        //     ).format('MM/DD/YYYY'),
        //     DateColor: this.eventFormGroup.controls['color'].value
        // });

        // this.eventFormGroup.controls['color'].reset();
        // this.eventFormGroup.controls['endDate'].reset();
        // this.eventFormGroup.controls['startDate'].reset();
        // this.eventFormGroup.controls['description'].reset();
        // this.eventFormGroup.controls['type'].reset();
    }

    getMonthEnd() {
        return new Date(moment().year(), moment().month() + 1, 0).getDate();
    }

    getMonthEndForCalendarDate(month) {
        return new Date(moment().year(), month, 0).getDate();
    }

    endDateSelected($event) {
        this.log.verbose($event);
    }

    tableFilter($event, type) {
        if (type == 'type') {
            this.CCTable.filter($event.value, 'ScheduledDateType', 'in');
        }
        if (type == 'desc') {
            this.CCTable.filter($event.value, 'ScheduledDatePurpose', 'in');
        }
    }
}
interface EventClickInfo {
    // The associated Event Object.
    event: EventModel;

    // The HTML element for this event.
    el: HTMLElement;

    // The native JavaScript event with low-level information such as click coordinates.
    jsEvent: any;

    view: any;
}
interface EventModel {
    id: string;
    groupId: string;
    allDay: boolean;
    start: Date;
    end: Date;
    title: string;
    url: string;
    classNames: string[];
    editable: boolean;
    startEditable: boolean;
    durationEditable: boolean;
    resourceEditable: boolean;
    rendering: string;
    overlap: boolean;
    constraint: any;
    backgroundColor: string;
    borderColor: string;
    textColor: string;
    extendedProps: any;
    source: any;
    data: any;
}
